var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdwProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b995a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31859,
    stopColor: "#d3445d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#e31836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#871836"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g40007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g40013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g40015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40021",
    className: "cls-1",
    d: "M51.85471,64.89393c-.79759,1.44528-1.1,2.8643-.5407,3.96107,1.74315,3.42166,9.84155,3.37297,17.62463.11275,1.95781-.81938,3.7324-1.77585,5.26541-2.8028,4.56073-3.05521,6.32827-6.50185,5.02322-9.06313-1.74385-3.42166-8.82029-3.7849-16.60283-.52532-.83349.34915-1.63296.72008-2.39474,1.10831l-.65409.00449c1.10962-.60989,2.34985-1.23515,3.60297-1.75984,8.8479-3.7061,17.62784-3.55683,19.60997.33313,1.4882,2.92068-.77836,7.00091-5.9945,10.48023-1.73165,1.15507-3.90147,2.33641-6.10594,3.26022-8.84852,3.70546-17.71371,3.47675-19.69584-.41321-.70211-1.37738-.58105-2.99243.34847-4.70166l.51379.00577h.00016ZM53.66839,62.41529c.50613-.56184,1.03205-1.00965,1.68747-1.55483l.01666-.4177c-.81871.65153-1.55163,1.31844-2.18781,1.9879l.48369-.01538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40025",
    className: "cls-1",
    d: "M54.33398,62.18786c-.63939,2.41457-2.58563,3.36656-4.54665,3.36656-2.77144,0-3.69517-1.68488-3.1641-4.18402.44521-2.45621,2.26719-4.11867,4.93931-4.11867,1.99434,0,3.51132.80913,2.99432,3.52096h-2.87326c.18198-1.28961-.10956-1.4645-.49331-1.45938-.80979,0-1.06215.82707-1.33063,2.08977-.25432,1.19736-.37858,2.08977.40939,2.08977.40486,0,.72901-.2396,1.12558-1.30498h2.93926"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path40027",
    className: "cls-1",
    d: "M58.44559,59.24733h.30562c.50292,0,.75849.18579.88792.5029.13772.32865.08454.88665-.07812,1.65285-.16274.7662-.3466,1.3242-.62461,1.65221-.26394.31776-.59833.50354-1.10126.50354h-.30624l.91677-4.31151h-.00008ZM54.08733,65.35134h3.89123c2.43055,0,4.30062-1.47539,4.80738-3.86114.49776-2.34154-.15054-4.03539-3.31464-4.03539h-3.7055l-1.67847,7.89653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40029",
    className: "cls-1",
    d: "M63.47842,57.45482h2.80084l-.38632,4.95599h.02182l1.78671-4.95599h3.23847l-.32032,4.95599h.02182l1.72078-4.95599h2.80084l-3.38518,7.8946h-3.39151l.35559-5.12192h-.02182l-1.82135,5.12191h-3.39151l-.02886-7.89461h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.65678,33.57586l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.97776,41.82896l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.88447,51.81206l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdwProductsScraper);
export default __webpack_public_path__ + "static/media/cdw-products-scraper.a9c61aa45fb7930351589648c0ee0f19.svg";
export { ForwardRef as ReactComponent };